module.exports = __webpack_public_path__ + "img/sweater.d5ef185e.png";